/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FcsPermissionSttHanging = {
  permission_hanging_incoming_enable: new FcsFlag.Flag(false),
  permission_hanging_last_mile_enable: new FcsFlag.Flag(false),
  permission_button_update_missing_enable: new FcsFlag.Flag(false),
  permission_button_update_damage_enable: new FcsFlag.Flag(false),
  permission_hanging_outgoing_enable: new FcsFlag.Flag(false),
  permission_hanging_bkd_console_enable: new FcsFlag.Flag(false),
  permission_hanging_bkd_pos_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionSttHanging() {
  FcsFlag.register("featureSttHanging", FcsPermissionSttHanging);
}
